"use client"

import styles from "../../index.module.scss"
import { AdComponentTypes } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

export default function Video(props: AdComponentTypes) {
  const { AdList, style } = props
  // console.error("视频广告组建错误, 未开发完成");
  return (
    <div className={`${prefixCls} ${styles.movie}`} style={style}>
      <div className={styles.artLabelImg}>
        <ul className={styles.list}>
          {AdList.adverts?.map((item) => (
            <li className={styles.smallAdv} key={item.id}>
              <a href={item.link_url} target="_blank" rel="noreferrer">
                <iframe
                  title="ad"
                  frameBorder={0}
                  height={AdList.width}
                  width={AdList.len}
                  src={"https://player.youku.com/embed/XMzU0ODk0MzQ0MA=="}
                  allowFullScreen
                ></iframe>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
